/**
 * @generated SignedSource<<7822489af01d7638e36d274c8ad6fa19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SalesforceSendNotesAutomationQuery$variables = {
  noteId: string;
};
export type SalesforceSendNotesAutomationQuery$data = {
  readonly note: {
    readonly sendNoteAutomationIsActive?: boolean;
    readonly sendNoteToCrmAutomationIsValid?: boolean;
  } | null;
};
export type SalesforceSendNotesAutomationQuery = {
  response: SalesforceSendNotesAutomationQuery$data;
  variables: SalesforceSendNotesAutomationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "noteId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendNoteToCrmAutomationIsValid",
      "storageKey": null
    },
    {
      "alias": "sendNoteAutomationIsActive",
      "args": null,
      "kind": "ScalarField",
      "name": "sendNoteToSalesforceAutomationIsActive",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceSendNotesAutomationQuery",
    "selections": [
      {
        "alias": "note",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SalesforceSendNotesAutomationQuery",
    "selections": [
      {
        "alias": "note",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bdbbcc0d1884e8a6755b6b368bc4f385",
    "id": null,
    "metadata": {},
    "name": "SalesforceSendNotesAutomationQuery",
    "operationKind": "query",
    "text": "query SalesforceSendNotesAutomationQuery(\n  $noteId: ID!\n) {\n  note: node(id: $noteId) {\n    __typename\n    ... on Note {\n      sendNoteToCrmAutomationIsValid\n      sendNoteAutomationIsActive: sendNoteToSalesforceAutomationIsActive\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3fc2eab0a8c817252732bb8c913a6c85";

export default node;
